import React, { useCallback } from 'react';
import t from 'prop-types';
import { Icon } from './Icon';
import classNames from 'classnames';

export const FilterToggle = ({
  isOpen,
  setOpen,
  count,
  appliedFilters,
  sm,
}) => {
  const filterCount =
    typeof count === 'number'
      ? count
      : appliedFilters
        ? appliedFilters.filter(Boolean).size
        : 0;
  const toggle = useCallback(() => setOpen(v => !v), [setOpen]);

  return (
    <button
      className={classNames('btn btn-link-primary', { 'btn-sm': sm })}
      onClick={toggle}
    >
      <Icon name="sliders" />
      <span>{`${isOpen ? 'Hide' : 'Show'} Filters`}</span>
      {filterCount > 0 && (
        <span className="badge badge-sm badge-danger text-danger ms-1">
          {filterCount}
        </span>
      )}
    </button>
  );
};

FilterToggle.propTypes = {
  // Boolean defining if filters are open
  isOpen: t.bool.isRequired,
  // Setter function for toggling the isOpen state
  setOpen: t.func.isRequired,
  // Count of active filters to display in the button
  count: t.number,
  // appliedFilters object from RKL tables used to determine the count
  appliedFilters: t.object,
  // Predefined size for the button
  sm: t.bool,
};
